import { Stack } from '@mui/material';

import { Accordion } from '@/types/accordion.type';

import styles from './AccordionMenu.module.scss';
import AccordionMenuItem from './AccordionMenuItem';

interface AccordionMenuProps {
  accordionList: Accordion[];
}

const AccordionMenu = ({ accordionList }: AccordionMenuProps) => (
  <Stack spacing={0} className={styles.container}>
    {accordionList.map((menu, index) => (
      <AccordionMenuItem key={`faq-${index + 1}`} {...menu} />
    ))}
  </Stack>
);

export default AccordionMenu;
